import script from "./Progress_circle_test.vue?vue&type=script&setup=true&lang=js"
export * from "./Progress_circle_test.vue?vue&type=script&setup=true&lang=js"

import "./Progress_circle_test.vue?vue&type=style&index=0&id=98021c56&lang=css"

const __exports__ = script;

export default __exports__